import { SquarePen, X } from 'lucide-react';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';

import {
    sessionState,
    useChatInteract,
    useChatMessages
} from '@chainlit/react-client';

export default function SessionBudgetDock() {
    const session = useRecoilValue(sessionState);
    const { threadId, messages } = useChatMessages();
    const { clear } = useChatInteract();
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const userMessageCount = messages.filter(
        (message) => message.type === 'user_message'
    ).length;

    useEffect(() => {
        if (!session?.socket) return;
        const handleBudgetReached = (event: { thread_id: string }) => {
            if (threadId && event.thread_id !== threadId) return;
            setOpen(true);
        };
        session.socket.on('session_budget_reached', handleBudgetReached);
        return () => {
            session.socket.off('session_budget_reached', handleBudgetReached);
        };
    }, [session?.socket, threadId]);

    useEffect(() => {
        setOpen(false);
    }, [userMessageCount, threadId]);

    const close = useCallback(() => setOpen(false), []);

    const startNewChat = useCallback(() => {
        window.dispatchEvent(new CustomEvent('newChat'));
        clear();
        navigate('/');
        close();
    }, [clear, navigate, close]);

    if (!open) return null;

    return (
        <div className="mb-2 flex items-center justify-between gap-4 rounded-xl border bg-white px-4 py-3 composer-shadow dark:bg-sidebar-accent">
            <span className="text-sm">
                This conversation is getting long. Consider starting a new chat,
                or continue here.
            </span>
            <div className="flex shrink-0 items-center gap-2 text-sm">
                <button
                    onClick={startNewChat}
                    className="flex items-center gap-1 rounded-md bg-foreground px-3 py-1 text-background"
                >
                    <SquarePen className="size-3.5" /> New chat
                </button>
                <button
                    onClick={close}
                    className="text-muted-foreground hover:text-foreground"
                >
                    <X className="size-4" />
                </button>
            </div>
        </div>
    );
}
